import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

let redux = reduxCreator.type('FORUM_CATEGORIES').plugin(axiosPlugin, {template: "multiSingle"});

let fetchForumChildrensAction = redux.fetchActionGetOne();

export const fetchForumCategories = (forumId, query = {}) => fetchForumChildrensAction(`/forums/${forumId}/childrens?${queryString.stringify(query)}`, null, {key: forumId});
export const resetForumCategories = (keys) => redux.actions.unsetKeys(keys);

export const forumCategories = redux.reducer();